import { useCallback, useContext, useMemo } from 'react';
import type { LooseString, TranslationKey } from '../types';
import ALL_TRANSLATIONS from './defaultTranslations';
import TranslationsContext from './NewTranslationsContext';

export default function useNewTranslations() {
  const { locale } = useContext(TranslationsContext);

  const translations = useMemo(
    () => ALL_TRANSLATIONS[locale] as Record<TranslationKey, string>,
    [locale],
  );
  const allTranslationsKeys = useMemo(() => Object.keys(translations), [translations]);

  const translate = useCallback(
    (key?: LooseString<TranslationKey> | null) => {
      const finalKey = key ?? '';

      if (!allTranslationsKeys.includes(finalKey)) {
        return finalKey;
      }

      return translations[finalKey as TranslationKey];
    },
    [allTranslationsKeys, translations],
  );

  return translate;
}
